// src/components/Footer.jsx
import React from 'react';

function SubFooter() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="py-4 bg-white text-center">
      <div className="container">
        <p className="mb-0 small text-muted">&copy; {currentYear} FSL Management Services Limited. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default SubFooter;